import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_PAGE } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseDeletePage, UseDeletePageProps } from './types'

export const useDeletePage = ({ name }: UseDeletePageProps): UseDeletePage => {
  const { t } = useTranslation('features/page')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_PAGE,
    onCompleted: async data => {
      const { deletePage } = data

      if (deletePage) {
        const { errors } = deletePage

        if (errors && errors.length > 0) {
          enqueueSnackbar(
            t('delete.action.error', { interpolation: { escapeValue: false }, pageName: name }),
            { variant: 'error' },
          )
        }
      } else {
        enqueueSnackbar(
          t('delete.action.success', { interpolation: { escapeValue: false }, pageName: name }),
          { variant: 'success' },
        )
      }
    },
    queriesToInvalidate: ['getPages'],
  })

  const deletePage: UseDeletePage['deletePage'] = id => void mutateAsync({ input: { id } })

  return { deletePage, loading }
}
